export const SKU_LOCATION_TYPE_REPAIRMAN = "repairman";
export const SKU_LOCATION_TYPE_WORKSHOP = "workshop";
